import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentRef,
    OnInit,
    Type,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { backdroopFadeIn, popupShootUp } from '../../../shared/animations/animations';
import { SopoDialogRef, SopoDialogSettings } from '../../interfaces/dialog';
import { combineLatest, Subscription } from 'rxjs';
import { ResizeService } from 'src/app/shared/services/resize/resize.service';
import { SplitScreenService } from 'src/app/game/splitScreen.service';

@Component({
    selector: 'app-sopo-dialog',
    templateUrl: './sopo-dialog.component.html',
    styleUrls: ['./sopo-dialog.component.scss'],
    animations: [popupShootUp, backdroopFadeIn],
    host: {
        '[class]': 'backdropClass',
        '[class.sopo-popup-side-betting]': 'sideBetting',
        '[style.zIndex]': 'zIndex',
    },
    standalone: false
})
export class SopoDialogComponent implements OnInit, AfterViewInit {
    private _fontSizeSubscription: Subscription;
    private _insertedComponentRef: ComponentRef<any>;
    closing = false;
    closingSubscription: Subscription | undefined;
    isGameContainer = false;
    backdropClass = "";


    @ViewChild('insertionPoint', { read: ViewContainerRef })
    insertionPoint: ViewContainerRef;

    componentCreated = false;
    outAnimation = false;
    closeButton = false;
    zIndex = 1;

    style: {[key: string]: string} = {};
    sideBetting: boolean = false;

    constructor(
        private ref: ChangeDetectorRef,
        public settings: SopoDialogSettings,
        private sopoDialogRef: SopoDialogRef,
        private resizeService: ResizeService,
        private splitScreenService: SplitScreenService,
    ) {
        if (this.settings.width != '') this.style.width = this.settings.width;
        if (this.settings.height != '') this.style.height = this.settings.height;
        if (this.settings.maxHeight != '') this.style.maxHeight = this.settings.maxHeight;
        if (this.settings.sideBetting) this.sideBetting = true;

        this.createFontSizeSubscription();
    }

    ngOnInit() {
        this.closingSubscription = this.sopoDialogRef.closing.subscribe(closing => {
            if (this.closing !== closing) {
                this.closing = closing;
                this.ref.detectChanges();
            }
        });

        if(this.isGameContainer) this.settings.sCss = [...this.settings.sCss, 'sopo-popup-grid-view'];
        if(this.sideBetting) this.settings.sCss = [...this.settings.sCss, 'sopo-popup-side-betting-container'];
        
        this.closeButton = this.settings.closeButton;
        if (this.settings.zIndex) this.zIndex = this.settings.zIndex; 
    }

    ngAfterViewInit(): void {
        if (this.settings.insertedComponentType) {
            this.loadInsertedComponent(this.settings.insertedComponentType);
            this.ref.detectChanges();
        }
    }

    private createFontSizeSubscription(): void {
        if (this.settings.isGameContainer) {
            const sopoPopupFontSize$ = this.resizeService.getSopoPopupFontSize();
            const gridView$ = this.splitScreenService.gridView$;
            const gamesListLength$ = this.splitScreenService.gameListLength$;
            this._fontSizeSubscription = combineLatest([gridView$, sopoPopupFontSize$, gamesListLength$]).subscribe(([gridView, fontSize, gamesListLength]) => {
                if (gridView && gamesListLength > 1 && gamesListLength <= 2) {
                    this.style.fontSize = `calc(${fontSize} * 0.8)`;
                } else if (gridView  && gamesListLength > 2) {
                    this.style.fontSize = `calc(${fontSize} * 0.6)`;
                } else {
                    this.style.fontSize = fontSize;
                }
                this.ref.markForCheck();
            });

        } else {
            this._fontSizeSubscription = this.resizeService.getSopoPopupFontSize().subscribe(fontSize => {
                this.style.fontSize = fontSize;
                this.ref.markForCheck();
            });
        }
    }

    loadInsertedComponent(componentType: Type<any>): void {
        this._insertedComponentRef = this.insertionPoint.createComponent(componentType);
        this.sopoDialogRef.insertedComponentRef = this._insertedComponentRef;
    }

    backdropDismiss() {
        if (this.settings.backdropDismiss) this.dismiss();
    }

    dismiss() {
        this.sopoDialogRef.close(null);
    }

    animationDone(event: any) {
        if (event.triggerName === 'popupShootUp' && event.toState === 'void') {
            this.sopoDialogRef.outAnimationDone();
        }
    }

    outAnimationStarted(event: any) {
        if (event.triggerName === 'popupShootUp' && event.toState === 'void') {
            this.outAnimation = true;
            this.ref.detectChanges();
        }
    }

    ngOnDestroy(): void {
        this._insertedComponentRef.destroy();
        if (!this.closing) this.sopoDialogRef.close(null);
        if (this.closingSubscription) this.closingSubscription.unsubscribe();
        if (this._fontSizeSubscription) this._fontSizeSubscription.unsubscribe();
    }
}
